export default __webpack_public_path__ + "static/media/Ballroll_00287.68280d2b.png";